export default "__VITE_ASSET__D4G1i7oR__"